<template>
	<div class="material text" :style="style" v-bind:class="{
		'focus': has_focus,
		'has-value': !! input,
		'disabled': disabled,
	}">
		<div class="label">{{ label }}</div>
		<input
			ref="input"
			:disabled="disabled"
			:type="password ? 'password' : 'text'"
			v-model="input"
			v-on:focus="has_focus = true; $emit('focus');"
			v-on:blur="has_focus = false; $emit('blur');"
			v-on:keyup.enter="$emit('enter')" />
	</div>
</template>

<script>
export default {
  props: [
    'value',
    'label',
    'disabled',
    'password',
    'width'
  ],
  data: () => ({
    has_focus: false
  }),
  computed: {
    style () {
      return this.width ? ('width: ' + this.width + 'px') : ''
    },
    input: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    focus () {
      setTimeout(() => this.$refs.input.focus(), 10)
    }
  }
}
</script>
